const chai          = require('chai');
const PayPlus       = require('../index');
const expect        = chai.expect;

/**
 * Unit tests for payplus-node package
 * API Functions tested:
 * - retainerAction
 * - storeCard
 * - getCard
 * - editCard
 * - deleteCard
 * - issuePayment
 * - checkPayment
 */
describe('payplus-node tests', function() {

    let options = {
        username : 'user1',
        password : '11111-22222-33333-44444-55555',
        cashierNum : '01',
        merchantNum : '0963595010'
    };

    const username = options.username;
    delete options.username;
    it('should fail to generate client: missing username', function(done) {
        PayPlus.generateClient(options, function(err) {
            console.log('Error:', err.message);
            expect(err.name).to.equal('InvalidParametersError');
            options.username = username;
            done();
        });
    });

    const password = options.password;
    delete options.password;
    it('should fail to generate client: missing password', function(done) {
        PayPlus.generateClient(options, function(err) {
            expect(err.name).to.equal('InvalidParametersError');
            console.log('Error:', err.message);
            options.password = password;
            done();
        });
    });

    const cashierNum = options.cashierNum;
    delete options.cashierNum;
    it('should fail to generate client: missing cashierNum', function(done) {
        PayPlus.generateClient(options, function(err) {
            expect(err.name).to.equal('InvalidParametersError');
            console.log('Error:', err.message);
            options.cashierNum = cashierNum;
            done();
        });
    });

    const merchantNum = options.merchantNum;
    delete options.merchantNum;
    it('should fail to generate client: missing merchantNum', function(done) {
        PayPlus.generateClient(options, function(err) {
            expect(err.name).to.equal('InvalidParametersError');
            console.log('Error:', err.message);
            options.merchantNum = merchantNum;
            done();
        });
    });

    it('should fail to generate client: non-string parameters', function(done) {
        PayPlus.generateClient({
            username : 'user1',
            password : '11111-22222-33333-44444-55555',
            cashierNum : '01',
            merchantNum: 963595010
        }, function(err) {
            expect(err.name).to.equal('InvalidParametersError');
            console.log('Error:', err.message);
            done();
        });
    });

    let client;
    it('should generate PayPlus client successfully', function(done) {
        PayPlus.generateClient(options, function(err, c) {
            expect(err).to.equal(null);
            expect(c.constructor.name).to.equal('PayPlusClient');
            client = c;
            done();
        })
    });

    let options2 = {
        expMonth: 9,
        expYear: 2020,
        cardNumber: '5326101300004951'
    };

    it('should fail retainerAction - invalid action', function(done) {
        client.retainerAction('INVALID ACTION', options2, function(err, result) {
           expect(err.name).to.equal('InvalidParametersError');
           expect(result).to.be.undefined;
           done();
        });
    });

    const ACTION_ADD = 'ADD';

    const expMonth = options2.expMonth;
    delete options2.expMonth;
    it('should fail retainerAction - no expMonth', function(done) {
        client.retainerAction(ACTION_ADD, options2, function(err, result) {
            expect(err.name).to.equal('InvalidParametersError');
            expect(result).to.be.undefined;
            options2.expMonth = expMonth;
            done();
        });
    });

    const expYear = options2.expYear;
    delete options2.expYear;
    it('should fail retainerAction - no expYear', function(done) {
        client.retainerAction(ACTION_ADD, options2, function(err, result) {
            expect(err.name).to.equal('InvalidParametersError');
            expect(result).to.be.undefined;
            options2.expYear = expYear;
            done();
        });
    });

    const cardNumber = options2.cardNumber;
    delete options2.cardNumber;
    it('should fail retainerAction - no cardNumber', function(done) {
        client.retainerAction(ACTION_ADD, options2, function(err, result) {
            expect(err.name).to.equal('InvalidParametersError');
            expect(result).to.be.undefined;
            options2.cardNumber = cardNumber;
            done();
        });
    });

    it('should succeed retainerAction', function(done) {
        client.retainerAction(ACTION_ADD, options2, function(err, result) {
            expect(err).to.equal(null);
            expect(result.action).to.equal(ACTION_ADD);
            expect(result).to.have.property('token');
            done();
        });
    });
    
    function failStoreCardInvalidParams(card, month, year, done) {
        client.storeCard(card, month, year, function(err) {
            expect(err.name).to.equal('InvalidParametersError');
            console.log('Error:', err.message);
            done();
        })
    }

    let cardNum = '5326101300004951';

    it('should fail storeCard - invalid cardNumber', function(done) {
        failStoreCardInvalidParams(1, 10, 2018, done);
    });

    it('should fail storeCard - invalid cardNumber', function(done) {
        failStoreCardInvalidParams('0000000000000000', 10, 2018, done);
    });

    it('should fail storeCard - invalid expMonth #2', function(done) {
        failStoreCardInvalidParams(cardNum, 13, 2018, done);
    });

    it('should fail storeCard - invalid expMonth #3', function(done) {
        failStoreCardInvalidParams(cardNum, -1, 2018, done);
    });

    it('should fail storeCard - invalid expMonth #4', function(done) {
        failStoreCardInvalidParams(cardNum, 0, 2018, done);
    });

    it('should fail storeCard - invalid expMonth #5', function(done) {
        failStoreCardInvalidParams(cardNum, 'Month', 2018, done);
    });

    it('should fail storeCard - invalid expMonth #6', function(done) {
        failStoreCardInvalidParams(cardNum, null, 2018, done);
    });

    it('should fail storeCard - invalid expYear', function(done) {
        failStoreCardInvalidParams(cardNum, 12, 0, done);
    });

    it('should fail storeCard - invalid expYear #2', function(done) {
        failStoreCardInvalidParams(cardNum, 12, -2018, done);
    });

    it('should fail storeCard - invalid expYear #4', function(done) {
        failStoreCardInvalidParams(cardNum, 12, null, done);
    });


    let guid;
    it('should succeed storeCard', function(done) {
        client.storeCard(cardNum, 12, '2018', function(err, result) {
            expect(err).to.equal(null);
            expect(result.action).to.equal(ACTION_ADD);
            expect(result).to.have.property('token');
            guid = result.token;
            done();
        });
    });

    it('should succeed storeCard #2', function(done) {
        client.storeCard(cardNum, '9', 2019, function(err, result) {
            expect(err).to.equal(null);
            expect(result.action).to.equal(ACTION_ADD);
            expect(result).to.have.property('token');
            expect(guid).to.not.equal(null);
            // Same card storing results in editing the existing entry
            expect(result.token).to.equal(guid);
            done();
        });
    });

    it('should fail to get card - null token', function(done) {
        client.getCard(null, function(err, result) {
            expect(err.name).to.equal('InvalidParametersError');
            console.log('Error:', err.message);
            expect(result).to.be.undefined;
            done();
        });
    });


    it('should fail getCard - token not guid', function(done) {
        client.getCard('NON_GUID', function(err, result) {
            expect(err.name).to.equal('InvalidParametersError');
            console.log('Error:', err.message);
            expect(result).to.be.undefined;
            done();
        });
    });

    it('should fail getCard - invalid token', function(done) {
        let someToken = '1ba54175-d0d0-4caa-8c25-9b004b533e0c';
        client.getCard(someToken, function(err, result) {
            expect(err.name).to.equal('PayPlusError');
            console.log('Error:', err.message);
            expect(result).to.be.undefined;
            done();
        });
    });

    it('should succeed getCard', function(done) {
        client.getCard(guid, function(err, result) {
            expect(err).to.equal(null);
            expect(result).to.deep.equal({
                action: 'GET',
                last4: '4951',
                type: 'mastercard',
                expMonth: '09',
                expYear: '19'
            });
            done();
        });
    });

});